
import { getLocalizedString } from "@icarius-localization/strings";

export const getRequestSnackbarText = (status) => {
    switch (status) {
        case "1": return getLocalizedString("requestCreatedOK");
        case "2": return getLocalizedString("requestDeletedOK");
        case "3": return getLocalizedString("requestChangeSentSnack");
        case "4": return getLocalizedString("requestChangeAcceptedSnack");
        case "5": return getLocalizedString("requestChangeRejectedSnack");
        case "6": return getLocalizedString("requestAccetedSnack");
        case "7": return getLocalizedString("requestRejectedSnack");
        default: return "";
    }
}

export const getRequestTypeName = (type) => {
    return {
        "VAC": getLocalizedString("holidays"),
        "PERM": getLocalizedString("permission"),
        "ANT": getLocalizedString("advance"),
        "AUM": getLocalizedString("raise"),
        "DES": getLocalizedString("firing"),
    }[type];
}

export const requestsIds = {
    holidays: "VAC",
    permission: "PERM",
    advance: "ANT",
    raise: "AUM",
    firing: "DES",
}